import React from 'react';
import { useTranslation } from 'react-i18next';
import './TestimonialsPage.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TestimonialsPage = () => {
  const { t } = useTranslation();
  const rawTestimonials = t('testimonials_page.testimonials', { returnObjects: true });
  const rawStories = t('testimonials_page.dealer_stories.stories', { returnObjects: true });

  const testimonials = [
    {
      id: 1,
      name: 'Ramesh Singh',
      location: rawTestimonials[0].location,
      initials: 'RS',
      text: rawTestimonials[0].text
    },
    {
      id: 2,
      name: 'Vijay Kumar',
      location: rawTestimonials[1].location,
      initials: 'VK',
      text: rawTestimonials[1].text
    },
    {
      id: 3,
      name: 'Akhilesh Prasad',
      location: rawTestimonials[2].location,
      initials: 'AP',
      text: rawTestimonials[2].text
    },
    {
      id: 4,
      name: 'Rajesh Yadav',
      location: rawTestimonials[3].location,
      initials: 'RY',
      text: rawTestimonials[3].text
    },
    {
      id: 5,
      name: 'Sunil Kumar',
      location: rawTestimonials[4].location,
      initials: 'SK',
      text: rawTestimonials[4].text
    },
    {
      id: 6,
      name: 'Manoj Singh',
      location: rawTestimonials[5].location,
      initials: 'MS',
      text: rawTestimonials[5].text
    }
  ];

  const dealerStories = [
    {
      id: 1,
      name: 'Agricon Traders',
      location: rawStories[0].location,
      text: rawStories[0].text,
      partnership: '3 Years',
      sales: '500+ Units'
    },
    {
      id: 2,
      name: 'Vaishali Krishi Kendra',
      location: rawStories[1].location,
      text: rawStories[1].text,
      partnership: '4 Years',
      sales: '750+ Units'
    },
    {
      id: 3,
      name: 'Sitamarhi Agro Center',
      location: rawStories[2].location,
      text: rawStories[2].text,
      partnership: '2 Years',
      sales: '400+ Units'
    },
    {
      id: 4,
      name: 'Motihari Farm Equipment',
      location: rawStories[3].location,
      text: rawStories[3].text,
      partnership: '5 Years',
      sales: '900+ Units'
    }
  ];

  const [liveTestimonials, setLiveTestimonials] = React.useState([]);

  React.useEffect(() => {
    const fetchLiveTestimonials = async () => {
      try {
        const isLocalHost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192.168.');
        const envApiUrl = process.env.REACT_APP_API_URL?.trim();
        const API_URL = envApiUrl && (isLocalHost || (!envApiUrl.includes("localhost") && !envApiUrl.includes("127.0.0.1"))) ? envApiUrl : '/api';
        
        const res = await fetch(`${API_URL}/testimonials`);
        const json = await res.json();
        if (json.success && Array.isArray(json.data) && json.data.length > 0) {
          const mapped = json.data.map(t => ({
            id: t._id,
            name: t.name,
            location: t.district,
            initials: t.name ? t.name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) : 'F',
            text: t.feedback
          }));
          setLiveTestimonials(mapped);
        }
      } catch (err) {
        console.error('Failed to fetch live testimonials:', err);
      }
    };
    fetchLiveTestimonials();
  }, []);

  const displayedTestimonials = liveTestimonials.length > 0 ? liveTestimonials : testimonials;

  return (
    <div className="testimonials-page">
      <Header />
      
      <main className="testimonials-main">
        <div className="container">
          <div className="testimonials-header">
            <h1 className="testimonials-title">{t('testimonials_page.title')}</h1>
            <p className="testimonials-subtitle">{t('testimonials_page.subtitle')}</p>
          </div>
          
          <div className="testimonials-grid">
            {displayedTestimonials.map((test) => (
              <div key={test.id} className="testimonial-card">
                <div className="stars">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} width="18" height="18" viewBox="0 0 24 24" fill="#f5a623" stroke="#f5a623" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                    </svg>
                  ))}
                </div>
                <p className="testimonial-text">{test.text}</p>
                <div className="testimonial-author">
                  <div className="author-avatar">{test.initials}</div>
                  <div className="author-info">
                    <h4 className="author-name">{test.name}</h4>
                    <p className="author-location">{test.location}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Dealer Success Stories Section */}
          <div className="dealer-stories-section">
            <div className="dealer-stories-header">
              <span className="badge-orange">{t('testimonials_page.dealer_stories.badge')}</span>
              <h2 className="dealer-stories-title">{t('testimonials_page.dealer_stories.title')}</h2>
              <p className="dealer-stories-subtitle">{t('testimonials_page.dealer_stories.subtitle')}</p>
            </div>
            
            <div className="dealer-stories-grid">
              {dealerStories.map((story) => (
                <div key={story.id} className="dealer-card">
                  <div className="dealer-card-top">
                    <div className="dealer-icon-wrap">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="8" r="4"></circle>
                        <path d="M10 11.5L8 20l4-2l4 2l-2-8.5"></path>
                      </svg>
                    </div>
                    <div className="dealer-card-info">
                      <h4 className="dealer-name">{story.name}</h4>
                      <p className="dealer-location">{story.location}</p>
                    </div>
                  </div>
                  
                  <div className="dealer-stars">
                    {[...Array(5)].map((_, i) => (
                      <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill="#f5a623" stroke="#f5a623" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                      </svg>
                    ))}
                  </div>
                  
                  <p className="dealer-text">{story.text}</p>
                  
                  <div className="dealer-metrics">
                    <div className="metric-box metric-green">
                      <div className="metric-label">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg>
                        {t('testimonials_page.dealer_stories.partnership_label')}
                      </div>
                      <div className="metric-value">{story.partnership}</div>
                    </div>
                    <div className="metric-box metric-orange">
                      <div className="metric-label">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                        {t('testimonials_page.dealer_stories.sales_label')}
                      </div>
                      <div className="metric-value">{story.sales}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>

      {/* WhatsApp FAB */}
      <div className="whatsapp-fab" onClick={() => window.open('https://wa.me/919631277264', '_blank')} style={{ cursor: 'pointer' }}>
        <svg viewBox="0 0 24 24" width="32" height="32" fill="white">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.438 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.414 0 .004 5.412 0 12.046c0 2.123.555 4.195 1.608 6.014L0 24l6.117-1.605a11.782 11.782 0 005.925 1.587h.005c6.632 0 12.043-5.414 12.047-12.048a11.821 11.821 0 00-3.526-8.513"/>
        </svg>
      </div>

      <Footer />
    </div>
  );
};

export default TestimonialsPage;


